import { DOCUMENT } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy
} from '@angular/core';
// import { ROUTES } from './sidebar-items';
import { AuthService } from 'src/app/core/service/auth.service';
import { BehaviorSubject } from 'rxjs';
import { User } from 'src/app/core/models/user';

declare const Waves: any;
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  public sidebarItems: any[];
  level1Menu = '';
  level2Menu = '';
  level3Menu = '';
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight: string;
  listMaxWidth: string;
  headerHeight = 60;
  routerObj = null;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    public authService: AuthService,
    private router: Router
  ) {

    this.authService.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('user'))
    );
    this.authService.user = JSON.parse(localStorage.getItem('user'));
    this.routerObj = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setActiveMenu(event.urlAfterRedirects);
        this.renderer.removeClass(this.document.body, 'overlay-open');
      }
    });
  }

  setActiveMenu(url: string) {
    if (!this.sidebarItems?.length) {
      return;
    }

    const currentUrl = url.split('?')[0].split('#')[0];

    this.level1Menu = '';
    this.level2Menu = '';
    this.level3Menu = '';

    for (const level1 of this.sidebarItems) {
      if (this.isSameRoute(level1.path, currentUrl)) {
        this.level1Menu = level1.moduleName;
        return;
      }

      if (level1.submenu?.length) {
        for (const level2 of level1.submenu) {
          if (this.isSameRoute(level2.path, currentUrl)) {
            this.level1Menu = level1.moduleName;
            this.level2Menu = level2.moduleName;
            return;
          }

          if (level2.submenu?.length) {
            for (const level3 of level2.submenu) {
              if (this.isSameRoute(level3.path, currentUrl)) {
                this.level1Menu = level1.moduleName;
                this.level2Menu = level2.moduleName;
                this.level3Menu = level3.moduleName;
                return;
              }
            }
          }
        }
      }
    }
  }

  isSameRoute(menuPath: string, currentUrl: string): boolean {
    if (!menuPath) {
      return false;
    }

    const normalizedMenuPath = menuPath.startsWith('/')
      ? menuPath
      : '/' + menuPath;

    return currentUrl === normalizedMenuPath ||
      currentUrl.startsWith(normalizedMenuPath + '/');
  }

  @HostListener('window:resize', ['$event'])
  windowResizecall(event) {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, 'overlay-open');
    }
  }
  callLevel1Toggle(event: any, element: any) {
    if (element === this.level1Menu) {
      this.level1Menu = '0';
    } else {
      this.level1Menu = element;
    }
    const hasClass = event.target.classList.contains('toggled');
    if (hasClass) {
      this.renderer.removeClass(event.target, 'toggled');
    } else {
      this.renderer.addClass(event.target, 'toggled');
    }
  }
  callLevel2Toggle(event: any, element: any) {
    if (element === this.level2Menu) {
      this.level2Menu = '0';
    } else {
      this.level2Menu = element;
    }
  }
  callLevel3Toggle(event: any, element: any) {
    if (element === this.level3Menu) {
      this.level3Menu = '0';
    } else {
      this.level3Menu = element;
    }
  }
  ngOnInit() {
    if (this.authService.currentUserValue) {
      this.sidebarItems = JSON.parse(
        localStorage.getItem('routeMenuItems')
      ) || [];

      this.setActiveMenu(this.router.url);
    }

    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }
  ngOnDestroy() {
    this.routerObj.unsubscribe();
  }
  initLeftSidebar() {
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + '';
    this.listMaxWidth = '500px';
  }
  isOpen() {
    return this.bodyTag.classList.contains('overlay-open');
  }
  checkStatuForResize(firstTime) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, 'ls-closed');
    } else {
      this.renderer.removeClass(this.document.body, 'ls-closed');
    }
  }

  mouseHover(e) {
    const body = this.elementRef.nativeElement.closest('body');
    const bigLogo = this.document.getElementById('big-Logo')
    const smallLogo = this.document.getElementById('small-Logo')

    if (body.classList.contains('submenu-closed')) {
      this.renderer.addClass(this.document.body, 'side-closed-hover');
      this.renderer.removeClass(this.document.body, 'submenu-closed');


      this.renderer.removeClass(bigLogo, 'hide-logo');
      this.renderer.removeClass(smallLogo, 'show-logo');
      this.renderer.addClass(bigLogo, 'show-logo');
      this.renderer.addClass(smallLogo, 'hide-logo');
    }
  }
  mouseOut(e) {
    const body = this.elementRef.nativeElement.closest('body');
    const bigLogo = this.document.getElementById('big-Logo')
    const smallLogo = this.document.getElementById('small-Logo')

    if (body.classList.contains('side-closed-hover')) {
      this.renderer.removeClass(this.document.body, 'side-closed-hover');
      this.renderer.addClass(this.document.body, 'submenu-closed');

      this.renderer.removeClass(bigLogo, 'show-logo');
      this.renderer.removeClass(smallLogo, 'hide-logo');
      this.renderer.addClass(bigLogo, 'hide-logo');
      this.renderer.addClass(smallLogo, 'show-logo');
    }
  }
}
